import React from "react";
import "./Products.css";
import "./Header.css";
import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import image from "../assets/images/image.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import ProductsData from "../data/ProductsData";
import ProductCard from "./ProductCard";

export default function Products() {
  return (
    
      <div className="category_outer_main">
        <div className="container-fluid">
          <div className="product_slider">
          <Swiper
            modules={[Navigation, Autoplay]}
           
            slidesPerView={4}
            loop={true}
            autoplay={{ delay: 5000 }}
            navigation
            pagination={{ clickable: true }}

            breakpoints={{
            320: {
              slidesPerView: 2,
             spaceBetween: 5,
            },
            480: {
              slidesPerView: 2,
             spaceBetween: 5,
            },
            768: {
              slidesPerView: 3,
             spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          }}

            >
            { ProductsData.map((item) => (
                <SwiperSlide key={item.id}>
                    <ProductCard product = {item} />
                </SwiperSlide>
            ))
            }
            
          </Swiper>
        </div>
        </div>
      </div>
    
  );
}
